import React, {useState} from 'react';
import {ReportForm, showWarningNotify} from "../../components";
import {Card, CardContent, Grid} from '@material-ui/core';
import {AutocompleteArrayInput, DateInput, ReferenceArrayInput, required, Title} from 'react-admin';
import env from "../../env";
import moment from 'moment'
import {downloadFilePost} from "../../components/FileDownload";


const ThanhToanDaiLyReport = ({...props}) => {
    const [loading, setLoading] = useState(false);
    const [values, setValues] = useState({
        merchantIds: [],
        fromDate: moment().format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
    });
    let timeout;

    function excelReport() {
        if (values.merchantIds.length == 0) {
            showWarningNotify('Cần chọn danh sách đại lý')
            return;
        }
        setLoading(true)
        const data = {
            fromDate: values.fromDate,
            toDate: values.toDate,
            merchantIds: values.merchantIds
        }
        downloadFilePost(`${env.reportURL}/reports/bc-thanh-toan-dai-ly`, 'bc-thanh-toan-dai-ly.xlsx', data).then(r => setLoading(false)).catch(e => setLoading(false))
    }

    function validate(val) {
        const errors = {};

        if (val.fromDate && val.toDate && (val.fromDate > val.toDate)) {
            errors.toDate = 'To date must be greater than From date'
        }

        setValues({
            ...values,
            merchantIds: val.merchantIds,
            fromDate: val.fromDate,
            toDate: val.toDate
        })

        return errors;
    }

    const onChange = (prop, e) => {
        if (!e) {
            return
        }

        let value
        if (e.target) {
            value = e.target.value ? e.target.value : e.target.checked;
        } else {
            value = e
        }
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(() => {
            setValues({...values, [prop]: value});
        }, 500);
    };
    return (
        <Card>
            <Title title="resources.bc-thanh-toan-dai-ly.name"/>
            <CardContent>
                <ReportForm validate={validate}
                            excelReport={excelReport}
                            params={values}
                            isLoading={loading}
                >
                    <Grid container spacing={8}>
                        <Grid item xs={12} sm={6}>
                            <DateInput source="fromDate" validate={required()} {...props}
                                       label={'resources.common.fromDate'}/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <DateInput source="toDate" validate={required()} {...props}
                                       label={'resources.common.toDate'}/>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <ReferenceArrayInput source="merchantIds"
                                                 reference="merchants"
                                                 validate={required()}
                                                 label={'resources.merchants.name'}
                                                 perPage={100}
                                                 style={{
                                                     minWidth: 200,
                                                 }}
                                                 filter={{enabled: true}}
                                                 sort={{field: 'name', order: 'ASC'}}
                                                 {...props}>
                                <AutocompleteArrayInput optionText="name"
                                                        onChange={(e) => onChange('merchantIds', e)}/>
                            </ReferenceArrayInput>
                        </Grid>

                    </Grid>
                </ReportForm>
            </CardContent>
        </Card>
    )
}

export default ThanhToanDaiLyReport
